import styles from '@/src/components/Public/Home/Funds/FundDetails/FundDetails/TokenDetails/TokenDetails.module.scss';

interface TokenDetailsLoaderProps {
    isTablet: boolean;
    isDesktop?: boolean;
}

export default function TokenDetailsLoader(props: TokenDetailsLoaderProps) {
    const { isTablet, isDesktop } = props;
    let skeletonData;

    if (isTablet && !isDesktop) {
        return null;
    }
    skeletonData = Array(isDesktop ? 3 : 1)
        .fill(null)
        .map((_, index) => ({
            _DB_id: index,
        }));

    return (
        <div className={styles.tokenDetailContainer}>
            {/* <h2 className={styles.title}>Tokens in this fund</h2> */}
            <h2 className={styles.title}>{' '}</h2>
            <div className={styles.tokensGroup}>
                {skeletonData.map((token) => (
                    <div className={styles.token} key={token._DB_id}>
                        <div className={styles.rowSkeleton}></div>
                    </div>
                ))}
            </div>
        </div>
    );
}
